import { stripIndent } from 'common-tags';
import { OrderPaid } from './components/OrderPaid';

export const orderPaidEmailTemplate = {
  label: 'Order Paid Confirmation',
  description: 'Sent when a customer successfully pays for an order',
  icon: 'CheckboxCircleLine',
  component: OrderPaid,
  defaultTemplate: {
    name: 'Order Paid Confirmation',
    subject: {
      en: 'Your order #{{ orderNumber }} is confirmed — {{ storeName }}',
      fr: 'Votre commande #{{ orderNumber }} est confirmée — {{ storeName }}',
      it: 'Il tuo ordine #{{ orderNumber }} è confermato — {{ storeName }}',
      es: 'Tu pedido #{{ orderNumber }} está confirmado — {{ storeName }}',
      de: 'Deine Bestellung #{{ orderNumber }} ist bestätigt — {{ storeName }}',
    },
    templateVariables: {
      order_paid: {
        body: {
          en: stripIndent`
            <p>Hi {{ customerFirstName }},</p>
            <p>Thank you for your purchase! Your order has been confirmed and is being processed.</p>
            <p><strong>Order:</strong> #{{ orderNumber }}<br/>
            <strong>Total:</strong> {{ orderTotal }}<br/>
            <strong>Date:</strong> {{ orderDate }}</p>
          `,
          fr: stripIndent`
            <p>Bonjour {{ customerFirstName }},</p>
            <p>Merci pour votre achat ! Votre commande a été confirmée et est en cours de traitement.</p>
            <p><strong>Commande :</strong> #{{ orderNumber }}<br/>
            <strong>Total :</strong> {{ orderTotal }}<br/>
            <strong>Date :</strong> {{ orderDate }}</p>
          `,
          it: stripIndent`
            <p>Ciao {{ customerFirstName }},</p>
            <p>Grazie per il tuo acquisto! Il tuo ordine è stato confermato ed è in fase di elaborazione.</p>
            <p><strong>Ordine:</strong> #{{ orderNumber }}<br/>
            <strong>Totale:</strong> {{ orderTotal }}<br/>
            <strong>Data:</strong> {{ orderDate }}</p>
          `,
          es: stripIndent`
            <p>Hola {{ customerFirstName }},</p>
            <p>¡Gracias por tu compra! Tu pedido ha sido confirmado y está siendo procesado.</p>
            <p><strong>Pedido:</strong> #{{ orderNumber }}<br/>
            <strong>Total:</strong> {{ orderTotal }}<br/>
            <strong>Fecha:</strong> {{ orderDate }}</p>
          `,
          de: stripIndent`
            <p>Hallo {{ customerFirstName }},</p>
            <p>Vielen Dank für deinen Einkauf! Deine Bestellung wurde bestätigt und wird bearbeitet.</p>
            <p><strong>Bestellung:</strong> #{{ orderNumber }}<br/>
            <strong>Gesamt:</strong> {{ orderTotal }}<br/>
            <strong>Datum:</strong> {{ orderDate }}</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'orderNumber', label: 'Order Number', example: '1042' },
    { key: 'orderSubtotal', label: 'Order Subtotal', example: '$134.99' },
    { key: 'orderShipping', label: 'Order Shipping', example: '$14.99' },
    { key: 'orderTax', label: 'Order Tax', example: '$8.20' },
    { key: 'orderDiscount', label: 'Order Discount', example: '$5.00' },
    { key: 'orderTotal', label: 'Order Total', example: '$153.18' },
    { key: 'orderDate', label: 'Order Date', example: 'April 2, 2026' },
    { key: 'orderItemsHtml', label: 'Order Items (HTML table)', example: '<table>...</table>' },
  ],
  utmParameters: {
    utmSource: 'order_paid',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
    },
    order: {
      id: 'ord_preview_1042',
      orderNumber: '1042',
      status: 'paid',
      paidAt: new Date(),
      currency: 'USD',
      totalAmount: 14999,
      items: [
        { productName: 'Premium Widget', variantName: 'Large / Black', quantity: 2, unitAmount: 4999 },
        { productName: 'Starter Kit', variantName: '', quantity: 1, unitAmount: 5001 },
      ],
      customer: { firstName: 'John', lastName: 'Doe', email: 'john@example.com', locale: 'en-US' },
      store: { id: 'store_preview', name: storeName },
    },
  }),
  defaultMessages: {
    order_title: 'Order Confirmation',
    order_subtitle: 'Thank you for your purchase',
    cta_button: 'View Order',
    footer_text: '© 2025 All rights reserved',
  },
};
